import { Button, Stack, TableCell, TableRow } from '@mui/material';
import type { SessionDto } from '@/types/dtos/sessions/session.dto.ts';
import { SessionDetails } from '@/components/events/detail/tabs/sessions/session-details.tsx';
import { SessionContributorList } from '../session-actors/session-contributor-list.tsx';
import { MediaList } from '@/components/events/detail/tabs/common/media/media.list.tsx';
import { useTranslations } from '@/i18n/use-translations.tsx';
import { usePreferencesStore } from '@/state/stores/use-preferences-store.ts';
import { useEventStore } from '@/state/stores/use-event-store.ts';
import { useSearchParams } from 'react-router';
import sessionTypeToIcon from '../helpers/session-type-to-icon.helper.tsx';
import { MEDIA_PARENT_ENTITY } from '@/types/dtos/media/media-parent-entity.enum';

const EditButton = ({ session }: { session: SessionDto }) => {
  const t = useTranslations();
  const { setPreferences } = usePreferencesStore();
  const { setSelectedSession } = useEventStore();
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <Stack direction="row" spacing={2} alignItems="center" sx={{ flex: 1 }}>
      <Button
        color="info"
        size="small"
        variant="contained"
        onClick={(e) => {
          e.stopPropagation();
          setSelectedSession(session);
          searchParams.set('key', session.id);
          setSearchParams(searchParams);
          setPreferences({ sessionExpandedView: true });
        }}
        sx={{
          minWidth: 'unset',
          padding: '2px 8px',
        }}
      >
        {t('common.edit')}
      </Button>
    </Stack>
  );
};

export const SessionTableRow = ({ session }: { session: SessionDto }) => {
  return (
    <TableRow>
      <TableCell sx={{ verticalAlign: 'top' }}>{sessionTypeToIcon(session.type)}</TableCell>
      <TableCell sx={{ verticalAlign: 'top' }}>
        <Stack direction="row" spacing={2} alignItems="center">
          <SessionDetails session={session} />
          <EditButton session={session} />
        </Stack>
      </TableCell>
      <TableCell sx={{ verticalAlign: 'top' }}>
        <SessionContributorList session={session} />
      </TableCell>
      <TableCell sx={{ verticalAlign: 'top' }}>
        <MediaList
          media={session.media}
          parentId={session.id}
          parentType={MEDIA_PARENT_ENTITY.SESSION}
          contextParentId={session.id}
          contextParentType={MEDIA_PARENT_ENTITY.SESSION}
          context="Session"
          entityId={session.id}
          enablePlayerSocket={false}
        />
      </TableCell>
    </TableRow>
  );
};
